import { useState } from "react";
// POST - GET
import axios from "axios";

export default function useAxios(baseUrl) {
  const [loading, setLoading] = useState(true);

  // const DefBaseUrl = "";
  // const DefBaseUrl = "http://localhost:8080";
  const DefBaseUrl = "/cors-proxy/https://travellingsalesman.herokuapp.com";

  function post(url, data, config) {
    return new Promise((resolve, reject) => {
      axios.post(DefBaseUrl + url, data, config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

  function put(url, data, config) {
    return new Promise((resolve, reject) => {
      axios.put(DefBaseUrl + url, data, config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

  function get(url, config) {
    return new Promise((resolve, reject) => {
      axios.get(DefBaseUrl + url, config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

  return { get, put, post, loading };
}
